import ReactCodeMirror, { DecorationSet, EditorState, EditorView } from '@uiw/react-codemirror'
import { Input } from '@common/ui/mantine'
import React from 'react'
import FieldData from '../../domain/entity/FieldData'
import ValidFieldNamesContext from '../misc/ValidFieldNamesContext'
import highlightFieldReferences from '../misc/highlightFieldReferences'

export type LabelLineInputProps = {
  title: string
  label: string
  setLabel: (label: string) => void
  availableFields: readonly FieldData[]
  errors: string | undefined
  editable: boolean
}

const LabelLineInput = ({ title, label, setLabel, availableFields, errors, editable }: LabelLineInputProps) => {
  const validFieldNames = availableFields.map((it) => it.field.name)

  const singleLineExtension = EditorState.transactionFilter.of((transaction) => {
    if (transaction.newDoc.lines > 1) {
      return []
    }
    return transaction
  })

  const highlightExtension = EditorView.decorations.of(
    (view: EditorView): DecorationSet => highlightFieldReferences(view, validFieldNames)
  )

  const theme = EditorView.theme({
    '&': {
      backgroundColor: 'transparent',
    },
    '&.cm-editor.cm-focused': {
      outline: 'none',
    },
  })

  return (
    <ValidFieldNamesContext.Provider value={validFieldNames}>
      <Input.Wrapper label={title} error={errors}>
        <Input component="div" multiline error={!!errors} disabled={!editable} style={{ display: 'block' }}>
          <ReactCodeMirror
            style={{ display: 'block', width: '100%' }}
            value={label}
            onChange={(it) => setLabel(it)}
            basicSetup={{
              foldGutter: false,
              lineNumbers: false,
              highlightActiveLine: false,
            }}
            indentWithTab={false}
            extensions={[theme, singleLineExtension, highlightExtension]}
            editable={editable}
          />
        </Input>
      </Input.Wrapper>
    </ValidFieldNamesContext.Provider>
  )
}

export default LabelLineInput
